var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mgr-logs" },
    [
      _c("el-card", { staticClass: "box-card", attrs: { shadow: "never" } }, [
        _c(
          "div",
          {
            staticClass: "card-header",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("span", [_vm._v("访问日志")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-header-actions" },
              [
                _c("span", { staticClass: "tip" }, [
                  _vm._v("集合：access_logs"),
                ]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", loading: _vm.loading },
                    on: { click: _vm.query },
                  },
                  [_vm._v("刷 新")]
                ),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "lg-filters" },
          [
            _c(
              "el-select",
              {
                staticClass: "f-s",
                attrs: { size: "small" },
                on: { change: _vm.search },
                model: {
                  value: _vm.filters.service,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "service", $$v)
                  },
                  expression: "filters.service",
                },
              },
              [
                _c("el-option", { attrs: { label: "全部服务", value: "" } }),
                _vm._v(" "),
                _c("el-option", {
                  attrs: { label: "诗词游戏", value: "shicigameservice" },
                }),
                _vm._v(" "),
                _c("el-option", {
                  attrs: { label: "数据服务", value: "dataservice" },
                }),
                _vm._v(" "),
                _c("el-option", {
                  attrs: { label: "飞天学习", value: "feitianstudyservice" },
                }),
                _vm._v(" "),
                _c("el-option", {
                  attrs: { label: "自动化测试", value: "autotestservice" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-select",
              {
                staticClass: "f-s",
                attrs: { size: "small" },
                on: { change: _vm.search },
                model: {
                  value: _vm.filters.event,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "event", $$v)
                  },
                  expression: "filters.event",
                },
              },
              [
                _c("el-option", { attrs: { label: "全部事件", value: "" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "访问", value: "access" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "登录", value: "login" } }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-input", {
              staticClass: "f-w",
              attrs: {
                size: "small",
                clearable: "",
                placeholder: "路径关键字",
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.search.apply(null, arguments)
                },
              },
              model: {
                value: _vm.filters.path,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "path", $$v)
                },
                expression: "filters.path",
              },
            }),
            _vm._v(" "),
            _c(
              "el-select",
              {
                staticClass: "f-s",
                attrs: { size: "small" },
                on: { change: _vm.search },
                model: {
                  value: _vm.filters.method,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "method", $$v)
                  },
                  expression: "filters.method",
                },
              },
              [
                _c("el-option", { attrs: { label: "全部方法", value: "" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "GET", value: "GET" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "POST", value: "POST" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "PUT", value: "PUT" } }),
                _vm._v(" "),
                _c("el-option", {
                  attrs: { label: "DELETE", value: "DELETE" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-select",
              {
                staticClass: "f-s",
                attrs: { size: "small" },
                on: { change: _vm.search },
                model: {
                  value: _vm.filters.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "status", $$v)
                  },
                  expression: "filters.status",
                },
              },
              [
                _c("el-option", { attrs: { label: "全部状态", value: "" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "200", value: "200" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "401", value: "401" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "403", value: "403" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "404", value: "404" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { label: "500", value: "500" } }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-input", {
              staticClass: "f-w",
              attrs: {
                size: "small",
                clearable: "",
                placeholder: "用户 / 账号",
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.search.apply(null, arguments)
                },
              },
              model: {
                value: _vm.filters.user,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "user", $$v)
                },
                expression: "filters.user",
              },
            }),
            _vm._v(" "),
            _c("el-date-picker", {
              staticClass: "f-d",
              attrs: {
                size: "small",
                type: "datetimerange",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "value-format": "timestamp",
              },
              model: {
                value: _vm.filters.range,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "range", $$v)
                },
                expression: "filters.range",
              },
            }),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: {
                  size: "small",
                  type: "primary",
                  icon: "el-icon-search",
                  loading: _vm.loading,
                },
                on: { click: _vm.search },
              },
              [_vm._v("查询")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.resetFilters } },
              [_vm._v("重置")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "lg-table-wrap",
          },
          [
            _c("table", { staticClass: "lg-table" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", { staticClass: "c-time" }, [_vm._v("时间")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "c-svc" }, [_vm._v("服务")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "c-ev" }, [_vm._v("事件")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "c-ip" }, [
                    _vm._v("来源IP / 归属地"),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "c-method" }, [_vm._v("方法")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "c-path" }, [_vm._v("路径")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "c-status" }, [_vm._v("状态")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "c-lat" }, [_vm._v("耗时")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "c-user" }, [_vm._v("用户")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "c-client" }, [_vm._v("客户端")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "c-note" }, [_vm._v("结果 / 说明")]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.logs, function (row, idx) {
                    return _c("tr", { key: row.ts + "-" + idx }, [
                      _c(
                        "td",
                        {
                          staticClass: "c-time",
                          attrs: { "data-label": "时间" },
                        },
                        [_vm._v(_vm._s(_vm.formatTime(row.ts)))]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "c-svc",
                          attrs: { "data-label": "服务" },
                        },
                        [_vm._v(_vm._s(_vm.serviceLabel(row.service)))]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "c-ev",
                          attrs: { "data-label": "事件" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "lg-tag",
                              class:
                                row.event === "login"
                                  ? "lg-tag--login"
                                  : "lg-tag--access",
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    row.event === "login" ? "登录" : "访问"
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "c-ip",
                          attrs: { "data-label": "来源IP" },
                        },
                        [
                          _c("div", [_vm._v(_vm._s(row.ip || "-"))]),
                          _vm._v(" "),
                          _vm.regionText(row)
                            ? _c("div", { staticClass: "lg-sub" }, [
                                _vm._v(_vm._s(_vm.regionText(row))),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "c-method",
                          attrs: { "data-label": "方法" },
                        },
                        [_vm._v(_vm._s(row.method))]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "c-path",
                          attrs: {
                            "data-label": "路径",
                            title:
                              (row.path || "") +
                              (row.query ? "?" + row.query : ""),
                          },
                        },
                        [
                          _vm._v("\n              " + _vm._s(row.path)),
                          row.query
                            ? _c("span", { staticClass: "lg-query" }, [
                                _vm._v("?" + _vm._s(row.query)),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "c-status",
                          attrs: { "data-label": "状态" },
                        },
                        [
                          _c("span", { class: _vm.statusClass(row.status) }, [
                            _vm._v(_vm._s(row.status)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "c-lat",
                          attrs: { "data-label": "耗时" },
                        },
                        [_vm._v(_vm._s(row.latencyMs) + " ms")]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "c-user",
                          attrs: { "data-label": "用户" },
                        },
                        [_vm._v(_vm._s(row.user || row.username || "-"))]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "c-client",
                          attrs: {
                            "data-label": "客户端",
                            title: row.ua || "",
                          },
                        },
                        [_vm._v(_vm._s(_vm.clientText(row) || "-"))]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "c-note",
                          attrs: { "data-label": "结果 / 说明" },
                        },
                        [
                          row.event === "login"
                            ? [
                                _c(
                                  "span",
                                  {
                                    class:
                                      row.result === "success"
                                        ? "lg-ok"
                                        : "lg-fail",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          row.result === "success"
                                            ? "成功"
                                            : "失败"
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                row.reason
                                  ? _c("span", { staticClass: "lg-reason" }, [
                                      _vm._v(_vm._s(row.reason)),
                                    ])
                                  : _vm._e(),
                              ]
                            : row.status >= 400 && row.error
                            ? _c(
                                "span",
                                {
                                  staticClass: "lg-fail",
                                  attrs: { title: row.error },
                                },
                                [_vm._v(_vm._s(row.error))]
                              )
                            : _c("span", { staticClass: "lg-muted" }, [
                                _vm._v(_vm._s(row.referer || "")),
                              ]),
                        ],
                        2
                      ),
                    ])
                  }),
                  _vm._v(" "),
                  !_vm.loading && _vm.logs.length === 0
                    ? _c("tr", [
                        _c(
                          "td",
                          { staticClass: "lg-empty", attrs: { colspan: "11" } },
                          [_vm._v("暂无日志数据")]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "lg-pager" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                layout: _vm.pagerLayout,
                "pager-count": _vm.isMobile ? 5 : 7,
                total: _vm.total,
                "current-page": _vm.page,
                "page-size": _vm.pageSize,
                "page-sizes": [20, 50, 100],
              },
              on: {
                "update:currentPage": function ($event) {
                  _vm.page = $event
                },
                "update:current-page": function ($event) {
                  _vm.page = $event
                },
                "update:pageSize": function ($event) {
                  _vm.pageSize = $event
                },
                "update:page-size": function ($event) {
                  _vm.pageSize = $event
                },
                "current-change": _vm.query,
                "size-change": _vm.onSizeChange,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }